import { render, staticRenderFns } from "./EditReceiptService.vue?vue&type=template&id=08a39bdf"
import script from "./EditReceiptService.vue?vue&type=script&lang=js"
export * from "./EditReceiptService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports